import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M450-284h60v-257h-60v257Zm30-323q14.45 0 24.225-9.775Q514-626.55 514-641q0-14.45-9.775-24.225Q494.45-675 480-675q-14.45 0-24.225 9.775Q446-655.45 446-641q0 14.45 9.775 24.225Q465.55-607 480-607Zm0 526q-140-35-230-162.5T160-523v-238l320-120 320 120v238q0 152-90 279.5T480-81Zm0-62q115-38 187.5-143.5T740-523v-196l-260-98-260 98v196q0 131 72.5 236.5T480-143Zm0-337Z"
}), 'SecurityTip', {
  viewBox: '0 -960 960 960'
});